/**
 * WHO DRAWS THE MAIN TABS (prototype v2, 2026-11-02, the Top bar layout).
 *
 * The prototype draws the six main screens as underline tabs in the PAGE HEAD, under the title. Most
 * JAZZ screens build their head with `Page` (Shell.tsx), which draws them there; a few draw their own
 * head (Integrations, Device management, SLD Studio…), and on those the shell draws the same tabs at
 * the top of the page instead, so no screen is ever without them.
 *
 * Each `Page` claims the tabs while it is mounted; the FIRST claimant draws them (a page that embeds
 * another `Page` must not draw them twice) and the shell draws its own row only while nobody claims.
 * Claims are made in a layout effect, so the shell's row never paints for a frame on a `Page` screen.
 */
import { create } from 'zustand';

interface HostState {
  claims: readonly number[];
  add: (id: number) => void;
  remove: (id: number) => void;
}

export const useMainTabsHost = create<HostState>((set, get) => ({
  claims: [],
  add: (id) => set({ claims: [...get().claims.filter((c) => c !== id), id] }),
  remove: (id) => set({ claims: get().claims.filter((c) => c !== id) }),
}));

let next = 0;
/** A claim id, unique for the life of the page. */
export function nextClaimId(): number {
  next += 1;
  return next;
}
